import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { icoZahranicnyRegExp } from 'enums/regExp';

const icoZahranicnyValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || icoZahranicnyRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
        }
    })
];

export default icoZahranicnyValidation;
